import {
	getres,
	post,
	upload,
	download,
} from '@/utils/request'

export function loginstatus(data) {
	return post('/login/isLoginUser', data)
}

export function userLogin(data) {
	return post('/login/userLogin', data)
}

export function Logout(data) {
	return post('/login/Logout', data)
}

export function sendVerifyCodeByMessage(data) {
	return post('/login/sendVerifyCodeByMessage', data)
}

export function sendVerifyCodeByMessageOptPassword(data) {
	return post('/login/sendVerifyCodeByMessageOptPassword', data)
}

export function addUser(data) {
	return post('/login/addUser', data)
}

export function queryPosition(data) {
	return post('/position/queryPosition', data)
}

export function optPassword(data) {
	return post('/login/optPassword', data)
}

export function collectPosition(data) {
	return post('/position/collectPosition', data)
}

export function requestPosition(data) {
	return post('/position/requestPosition', data)
}

export function optResume(data) {
	return post('/resume/optResume', data)
}

export function queryResume(data) {
	return post('/resume/queryResume', data)
}

export function queryCollectionPosition(data) {
	return post('/position/queryCollectionPosition', data)
}

export function deleteCollectionPosition(data) {
	return post('/position/deleteCollectionPosition', data)
}

export function queryRequestPosition(data) {
	return post('/position/queryRequestPosition', data)
}

export function deleteRequestPosition(data) {
	return post('/position/deleteRequestPosition', data)
}

export function uploadByOne(file, data) {
	return upload('/file/image', file, data)
}

export function uploadByDoc(file, data) {
	return upload('/file/doc', file, data)
}

export function addAdminUser(data) {
	return post('/login/addAdminUser', data)
}

export function addPosition(data) {
	return post('/position/addPosition', data)
}

export function queryPositionBackend(data) {
	return post('/position/queryPositionBackend', data)
}

export function optPosition(data) {
	return post('/position/optPosition', data)
}

export function queryResumeByPosIDAndTime(data) {
	return post('/resume/queryResumeByPosIDAndTime', data)
}

export function queryResumeByTime(data) {
	return post('/resume/queryResumeByTime', data)
}

export function exportExcelByUserList(data) {
	return post('/resume/exportExcelByUserList', data)
}

export function exportResumAsPDFByUserId(data) {
	return post('/resume/exportResumAsPDFByUserId', data)
}

export function downloadPDF(url, data, fileName) {
	return download(url, data, fileName)
}

export function deletePosition(data) {
	return post('/position/deletePosition', data)
}

export function exportResumAsDocxByUserId(data) {
	return post('/resume/exportResumAsDocxByUserId', data)
}

export function unLockResumeByUserId(data) {
	return post('/resume/unLockResumeByUserId', data)
}

export function uploadArticleFile(urlID, file, data) {
	return upload('/article/uploadArticleFile?name=' + urlID, file, data)
}

// export function uploadArticleFile(data) {
// 	return post('/article/uploadArticleFile', data)
// }

export function queryFileListOfArticle(data) {
	return post('/article/queryFileListOfArticle', data)
}

export function deleteFileOfArticle(data) {
	return post('/article/deleteFileOfArticle', data)
}

export function optArticle(data) {
	return post('/article/optArticle', data)
}

export function queryArticle(data) {
	return post('/article/queryArticle', data)
}

export function queryArticleListBackend(data) {
	return post('/article/queryArticleListBackend', data)
}

export function addNewArticle(data) {
	return post('/article/addNewArticle', data)
}

export function deleteArticle(data) {
	return post('/article/deleteArticle', data)
}

export function updateStatusOfArticle(data) {
	return post('/article/updateStatusOfArticle', data)
}

export function queryArticleList(data) {
	return post('/article/queryArticleList', data)
}

export function queryResumeByNameOfUser(data) {
	return post('/resume/queryResumeByNameOfUser', data)
}

export function exportPkgByUserList(data) {
	return post('/resume/exportPkgByUserList', data)
}